{
  "name": "google-auth-library",
  "version": "10.6.2",
  "author": "Google Inc.",
  "description": "Google APIs Authentication Client Library for Node.js",
  "engines": {
    "node": ">=18"
  },
  "main": "./build/src/index.js",
  "types": "./build/src/index.d.ts",
  "repository": {
    "type": "git",
    "directory": "packages/google-auth-library-nodejs",
    "url": "https://github.com/googleapis/google-cloud-node-core.git"
  },
  "keywords": [
    "google",
    "api",
    "google apis",
    "client",
    "client library"
  ],
  "dependencies": {
    "base64-js": "^1.3.0",
    "ecdsa-sig-formatter": "^1.0.11",
    "gaxios": "^7.1.4",
    "gcp-metadata": "8.1.2",
    "google-logging-utils": "1.1.3",
    "jws": "^4.0.0"
  },
  "devDependencies": {
    "@types/base64-js": "^1.2.5",
    "@types/jws": "^3.1.0",
    "@types/mocha": "^10.0.10",
    "@types/mv": "^2.1.0",
    "@types/ncp": "^2.0.8",
    "@types/node": "^24.0.0",
    "@types/sinon": "^21.0.0",
    "assert-rejects": "^1.0.0",
    "c8": "^10.1.3",
    "codecov": "^3.8.3",
    "gts": "^6.0.2",
    "is-docker": "^3.0.0",
    "jsdoc": "^4.0.4",
    "jsdoc-fresh": "^5.0.0",
    "jsdoc-region-tag": "^4.0.0",
    "karma": "^6.0.0",
    "karma-chrome-launcher": "^3.0.0",
    "karma-coverage": "^2.0.0",
    "karma-firefox-launcher": "^2.0.0",
    "karma-mocha": "^2.0.0",
    "karma-sourcemap-loader": "^0.4.0",
    "karma-webpack": "^5.0.1",
    "keypair": "^1.0.4",
    "mocha": "^11.1.0",
    "mv": "^2.1.1",
    "ncp": "^2.0.0",
    "nock": "^14.0.5",
    "null-loader": "^4.0.1",
    "puppeteer": "^24.0.0",
    "sinon": "^21.0.0",
    "ts-loader": "^9.5.2",
    "typescript": "5.8.3",
    "webpack": "^5.97.1",
    "webpack-cli": "^6.0.1"
  },
  "files": [
    "build/src",
    "!build/src/**/*.map"
  ],
  "scripts": {
    "test": "c8 mocha build/test",
    "clean": "gts clean",
    "prepare": "npm run compile",
    "lint": "gts check --no-inline-config",
    "compile": "tsc -p .",
    "fix": "gts fix",
    "pretest": "npm run compile -- --sourceMap",
    "docs": "jsdoc -c .jsdoc.js",
    "samples-setup": "cd samples/ && npm link ../ && npm run setup && cd ../",
    "samples-test": "cd samples/ && npm link ../ && npm test && cd ../",
    "system-test": "mocha build/system-test --timeout 60000",
    "presystem-test": "npm run compile -- --sourceMap",
    "webpack": "webpack",
    "browser-test": "karma start",
    "docs-test": "echo 'disabled until linkinator is fixed'",
    "predocs-test": "npm run docs",
    "prelint": "cd samples; npm link ../; npm install"
  },
  "license": "Apache-2.0",
  "homepage": "https://github.com/googleapis/google-cloud-node-core/tree/main/packages/google-auth-library-nodejs"
}
